import { translate } from '@thoughtspot/i18n';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import cx from 'classnames';
import { noop } from 'lodash';
import React from 'react';
import styles from '../../../styles/kpi.module.scss';
import { TEST_IDS } from './constants';
export const Analyze = React.memo(({ tooltip, isAnalyzeButtonEnabled, onChangeAnalysisClick, isPresentModeOn, handleKeyPress, shouldApplyMargin, isEmptyComparison, setIsCCAErrorModalOpen, }) => {
    return (React.createElement("div", { "data-testid": TEST_IDS.ANALYZE_BUTTON, className: cx(styles.analyze, {
            [styles.analyzeMargin]: shouldApplyMargin,
        }), ...tooltip },
        React.createElement(Button, { className: styles.analyzeBtn, isDisabled: !isAnalyzeButtonEnabled, type: "tertiary", size: "m", text: translate('ANALYZE_CHANGE_BUTTON_TEXT'), "data-testid": TEST_IDS.EXPLAIN_CHANGE_ICON, "data-tour-id": "tour_explain-change-icon", onClick: isEmptyComparison
                ? () => setIsCCAErrorModalOpen(true)
                : onChangeAnalysisClick, retainFocusOnClick: false, onKeyDown: isPresentModeOn ? handleKeyPress : noop })));
});
//# sourceMappingURL=analyze.js.map